<ng-container>
  <button (click)="onUploadBtnClick()">
    <ng-content></ng-content>
  </button>
  <input #uploadInput type="file" accept="text/csv" (change)="handleOnUpload($event.target.files)" style="display: none;">
</ng-container>
